export default [{
  text: '组件名称',
  name: 'name',
}, {
  name: 'text',
  text: '文本',
  type: 'html',
  language: 'html',
}, {
  text: '链接',
  name: 'href',
  trim: true,
}, {
  name: 'openInNewWindow',
  text: '是否在新窗口打开',
  extra: '仅在PC端浏览器内生效',
  type: 'switch',
  defaultValue: false,
  display: (vm) => {
    const { pageType } = vm.mForm.editor?.editorCore?.page?.value || { pageType: '' };
    return pageType?.toLowerCase().indexOf('pc') > -1;
  },
}, {
  type: 'component',
  id: 'rect',
}];
